import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-common-destination-name',
  templateUrl: './help-common-destination-name.component.html'
})
export class HelpCommonDestinationNameComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
